/**
 * @name engine
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgM2g2IiAvPgogIDxwYXRoIGQ9Ik0xMyAzdjQiIC8+CiAgPHBhdGggZD0iTTIgMTB2NiIgLz4KICA8cGF0aCBkPSJNMiAxM2g0IiAvPgogIDxwYXRoIGQ9Ik02IDE2YTIgMiAwIDAwMiAyaDFhMiAyIDAgMDExLjYuOGwuMy40YTIgMiAwIDAwMS42LjhoMi4yNjRhMiAyIDAgMDAxLjc4OS0xLjEwNmwxLjY3LTMuMzQxYTEgMSAwIDAxLjg5NS0uNTUzSDIxYTEgMSAwIDAwMS0xdi00YTEgMSAwIDAwLTEtMWgtMy41YTEgMSAwIDAxLS44LS40bC0uOS0xLjJBMSAxIDAgMDAxNSA3aC00YTEgMSAwIDAwLS44LjRsLS45IDEuMmExIDEgMCAwMS0uOC40SDdhMSAxIDAgMDAtMSAxeiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/engine
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const Engine: string = `
<svg
  class="lucide lucide-engine"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M10 3h6" />
  <path d="M13 3v4" />
  <path d="M2 10v6" />
  <path d="M2 13h4" />
  <path d="M6 16a2 2 0 002 2h1a2 2 0 011.6.8l.3.4a2 2 0 001.6.8h2.264a2 2 0 001.789-1.106l1.67-3.341a1 1 0 01.895-.553H21a1 1 0 001-1v-4a1 1 0 00-1-1h-3.5a1 1 0 01-.8-.4l-.9-1.2A1 1 0 0015 7h-4a1 1 0 00-.8.4l-.9 1.2a1 1 0 01-.8.4H7a1 1 0 00-1 1z" />
</svg>
`;

export default Engine;
